export default __webpack_public_path__ + "static/media/ayit_digital_logo.1b932861.png";